import { BulkDeployPage } from '@ion/ion-experimental';

export default BulkDeployPage;
